import { InventoryAvailabilityStatus } from '../../core/apis/inventoryApi';
// eslint-disable-next-line import/prefer-default-export
export const statusBadgeConfig = {
    [InventoryAvailabilityStatus.inStock]: {
        variant: 'available',
        label: 'Shared.Common.inStockLabel',
        icon: 'success',
    },
    [InventoryAvailabilityStatus.onItsWay]: {
        variant: 'onitsway',
        label: 'Shared.Common.onItsWayLabel',
        icon: 'onitsway',
    },
    [InventoryAvailabilityStatus.preOrder]: {
        variant: '',
        label: '',
        icon: '',
    },
};
